import { render, staticRenderFns } from "./ArtifactDetails.vue?vue&type=template&id=340681dd&scoped=true&"
import script from "./ArtifactDetails.vue?vue&type=script&lang=js&"
export * from "./ArtifactDetails.vue?vue&type=script&lang=js&"
import style0 from "./ArtifactDetails.vue?vue&type=style&index=0&id=340681dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340681dd",
  null
  
)

export default component.exports